export default {
    language: 'Sprache',
    organisation: 'Lieferant',
    roles: 'Rollen'
}
